import React from 'react';

import classNames from "classnames";
import styles from "../../../styles/athlete-widget.placeholder.module.scss";

export const AthleteWidgetRowScoresPlaceholder = () => {
  return (
    <div className={classNames(styles.row_scores)}>
      <div className={classNames(styles.row_score)}/>
      <div className={classNames(styles.row_score)}/>
    </div>
  )
};